import React from "react";
import { useTranslation } from "react-i18next";


const WhyCertificates = () => {
  const { t } = useTranslation("certificates"); // Hook to use translations

  return (
    <div className="container-class">
      <div className="p-5 md:p-[100px] space-y-10">
        <h1 className="web-heading-section">
          {t("why_distributor_certificates_matter")}
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 ">
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3 min-h-[266px]">
            <div className="max-w-[239px]">

              <h1 className="title-xl ">{t("trust_and_authenticity")}</h1>
              <p className="body-medium text-[#EEEEEE99] mt-4">
                {t("trust_and_authenticity_description")}
              </p>
            </div>

          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[239px]">


              <h1 className="title-xl">
                {t("commitment_to_quality")}
              </h1>
              <p className="body-medium text-[#EEEEEE99] mt-4">
                {t("commitment_to_quality_description")}
              </p>
            </div>

          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[239px]">


              <h1 className="title-xl">{t("recognition_and_motivation")}</h1>
              <p className="body-medium text-[#EEEEEE99] mt-4">
                {t("recognition_and_motivation_description")}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyCertificates;
